import { WBBox, WBTypography, WBDivider } from '@admiin-com/ds-web';

import {
  PaymentMethodType,
  SubscriptionTier,
  Task,
} from '@admiin-com/ds-graphql';
import { WBFlex } from '@admiin-com/ds-web';
import { calculateFee, isPayableTask } from '../../../../helpers/tasks';
import { CurrencyNumber } from '../../../../components/CurrencyNumber/CurrencyNumber';
import { t } from 'i18next';
import { INSTALLMENT_FEE } from '../../../../constants/config';
export const TaskAmounts = ({ tasks }: { tasks: Task[] }) => {
  const notPayable = tasks.every((task: Task) => !isPayableTask(task));
  const { fees, totalAmount, subTotal, tierAmount } = calculateFee(
    tasks,
    PaymentMethodType.CARD,
    [],
    SubscriptionTier.PRO
  );
  return !notPayable ? (
    <WBFlex
      width={'100%'}
      alignItems={{ xs: 'center', xl: 'end' }}
      mt={3}
      mb={1}
      flexDirection={{ xs: 'column' }}
    >
      <WBFlex flexDirection="column" minWidth="100%">
        <WBDivider />
        <WBFlex>
          <WBBox flex={1}>
            <WBTypography fontWeight="bold" fontSize={18}>
              {t('Amount', { ns: 'tasks' })}
            </WBTypography>
          </WBBox>
          <WBBox flex={1}>
            <CurrencyNumber
              fontWeight="bold"
              fontSize={18}
              number={subTotal}
              sup={false}
              textAlign="right"
            />
          </WBBox>
        </WBFlex>
        {Object.entries(fees).map(
          ([name, value], index) =>
            index > 0 && (
              <WBFlex key={name}>
                <WBBox flex={1}>
                  <WBTypography fontSize={14}>
                    {t(name, {
                      ns: 'taskbox',
                      ...(name === 'installmentFee'
                        ? { percent: INSTALLMENT_FEE }
                        : {
                            subscriptionTierFee: tierAmount
                              ? `(${tierAmount})`
                              : '',
                          }),
                    })}
                  </WBTypography>
                </WBBox>
                <WBBox flex={1}>
                  <CurrencyNumber
                    fontSize={'text.primary'}
                    textAlign={'right'}
                    number={value as number}
                    sup={false}
                    fontWeight="regular"
                  />
                </WBBox>
              </WBFlex>
            )
        )}
        <WBDivider
          sx={{
            my: 1,
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
          }}
        />
        <WBFlex alignItems="center">
          <WBBox flex={1}>
            <WBTypography mr={[0, 0, 0, 0, 4]} fontWeight="bold" fontSize={20}>
              Total
            </WBTypography>
          </WBBox>
          <WBBox flex={1}>
            <CurrencyNumber
              sup={false}
              number={totalAmount}
              fontSize={20}
              textAlign="right"
            />
          </WBBox>
        </WBFlex>
        <WBDivider
          sx={{
            my: 1,
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
          }}
        />
      </WBFlex>
    </WBFlex>
  ) : null;
};
